import partition from 'lodash/collection/partition';
import Radium from 'radium';
import React from 'react';
import sortBy from 'lodash/collection/sortBy';
import { RouteHandler, Link, State, Navigation } from 'react-router';
import { templateChildrenPages } from 'gatsby-helpers';

import ReindexTypography from '../ui/_ReindexTypography';

const { rhythm } = ReindexTypography;
const styles = {
  container: {
    maxWidth: 960,
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: `0 ${rhythm(1 / 2)} ${rhythm(1 / 2)} ${rhythm(1)} `,
  },
  desktop: {
    display: 'flex',
    '@media (max-width: 700px)': {
      display: 'none',
    },
  },
  mobile: {
    display: 'none',
    '@media (max-width: 700px)': {
      display: 'block',
    },
  },
  pageItem: {
    marginBottom: rhythm(1 / 2),
  },
  pageChildItem: {
    marginTop: rhythm(1 / 2),
  },
  pageLink: {
    textDecoration: 'none',
  },
  pageLinkActive: {
    textDecoration: 'none',
    fontWeight: ReindexTypography.options.boldWeight,
  },
};

const DocsPage = React.createClass({
  mixins: [State, Navigation],

  handleTopicChange(e) {
    this.transitionTo(e.target.value);
  },

  renderPageLink(page) {
    return (
      <Link
        to={page.path}
        style={styles.pageLink}
        activeStyle={{ ...styles.pageLink, fontWeight: 'bold' }}
        activeClass="active">
        {page.data.title}
      </Link>
    );
  },

  render() {
    const allPages = sortBy(templateChildrenPages(__filename, this.props.state),
      'data.order',
    );
    const [
      topLevelPages,
      nestedPages,
    ] = partition(allPages, (page) => page.file.name === 'index');

    const pages = topLevelPages.map((page) => ({
      ...page,
      children: nestedPages.filter((nestedPage) =>
        nestedPage.file.dirname === page.file.dirname
      ),
    }));

    const pageOptions = [];
    for (const page of pages) {
      pageOptions.push(
        <option key={page.path} value={page.path}>
          {page.data.title}
        </option>
      );
      for (const child of page.children) {
        pageOptions.push(
          <option key={child.path} value={child.path}>
            {page.data.title} - {child.data.title}
          </option>
        );
      }
    }

    const pageItems = pages.map((page) =>
      <li
        key={page.path}
        style={styles.pageItem}>
        {this.renderPageLink(page)}
        <ol style={{ marginBottom: 0 }}>
          {
            page.children.map((child) =>
              <li
                key={child.path}
                style={styles.pageChildItem}>
                {this.renderPageLink(child)}
              </li>
            )
          }
        </ol>
      </li>
    );

    return (
      <div style={styles.container}>
        <div style={styles.desktop}>
          <div
            style={{
              width: `calc(${rhythm(9)} - 1px)`,
              borderRight: '1px solid lightgrey',
            }}>
            <ul
              style={{
                listStyle: 'none',
                margin: `${rhythm(1 / 2)} 0 0`,
              }}>
              {pageItems}
            </ul>
          </div>
          <div
            style={{
              flex: 1,
              padding: `0 ${rhythm(1)} 0`,
            }}>
            <RouteHandler {...this.props} />
          </div>
        </div>
        <div style={styles.mobile}>
          <strong>Topics:</strong>
          {' '}
          <select
            defaultValue={this.props.state.path}
            onChange={this.handleTopicChange}>
            {pageOptions}
          </select>
          <br />
          <br />
          <RouteHandler {...this.props} />
        </div>
      </div>
    );
  },
});

export default Radium(DocsPage);



/** WEBPACK FOOTER **
 ** ./docs/_template.jsx
 **/